import { DefaultValues } from 'react-hook-form';
import makeForm from '../../../../components/Form';
import { AdubacaoRow } from '../../../../@types';

export const DEFAULT_VALUES: DefaultValues<AdubacaoRow> = {
  talhao: null,
  area: null,
  adubo: null,
  dose: null,
  unidade: null,
  identification: null,
};

export const FormAdubacao = makeForm<AdubacaoRow>();
